export default "__VITE_ASSET__4b0c02ca__"